import React, { Fragment } from "react";
import _ from "lodash";
import AuthRender from "../../AuthRender";
import moment from "moment";
import { Dropdown, Menu } from "antd";

const sectorsColumn = (userInfos, handleDisplayModalUsers, handleDisplayModalPdcs) => [
  {
    title: "id",
    dataIndex: "sector_id",
    key: "sector_id",
    render: (text, record, index) => {
      return <div>{record.sector_id}</div>;
    }
  },
  {
    title: "Nom",
    dataIndex: "sector_label",
    key: "sector_label",
    render: (text, record, index) => {
      return <div>{record.sector_label}</div>;
    }
  },
  {
    title: "Utilisateurs",
    dataIndex: "users",
    key: "users",
    render: (text, record, index) => {
      // const { sector_label } = record;
      const { users } = record;
      let usersFiltered = [];
      // const managerUsersInsideAllSectorUsers = [];
      //dont see other admins, or higher roles
      usersFiltered = users.filter(user => user.role_id >= userInfos.role_id && user.role_id > 1);

      // managerUsers.forEach(managerUser => {
      // 	managerUser.sectors.forEach(sector => {
      // 		if (sector.sector_label === sector_label)
      // 			managerUsersInsideAllSectorUsers.push(managerUser);
      // 	});
      // });

      if (usersFiltered.length === 0) {
        return (
          <Fragment>
            <AuthRender service={5} access={["modification"]}>
              <a className="ant-dropdown-link" onClick={() => handleDisplayModalUsers(usersFiltered, record)}>
                {usersFiltered.length} utilisateur(s)
              </a>
            </AuthRender>
            <AuthRender service={5} forbidden_access={["modification"]}>
              {usersFiltered.length} utilisateur(s)
            </AuthRender>
          </Fragment>
        );
      } else {
        return (
          <Dropdown
            overlay={
              <Menu>
                {users
                  .filter(user => user.role_id >= userInfos.role_id && user.role_id === 4)
                  .map(u => (
                    <Menu.Item>{u.email}</Menu.Item>
                  ))}
              </Menu>
            }
          >
            <a className="ant-dropdown-link" onClick={() => handleDisplayModalUsers(usersFiltered, record)}>
              {usersFiltered.length} utilisateur(s)
            </a>
          </Dropdown>
        );
      }

      /*
			const users = record.users || [];
			return (
				<a
					className="ant-dropdown-link"
					onClick={() => handleDisplayModalUsers(usersFiltered, record)}
				>
					{usersFiltered.length} utilisateur(s)
				</a>);
		*/
    }
  },
  {
    title: "PDCS",
    dataIndex: "salepoints",
    key: "salepoints",
    render: (text, record, index) => {
      const { salepoints } = record;

      if (salepoints.length === 0) {
        return (
          <Fragment>
            <AuthRender service={5} access={["modification"]}>
              <a className="ant-dropdown-link" onClick={() => handleDisplayModalPdcs(salepoints, record)}>
                {salepoints.length} pdcs(s)
              </a>
            </AuthRender>
            <AuthRender service={5} forbidden_access={["modification"]}>
              {salepoints.length} pdcs(s)
            </AuthRender>
          </Fragment>
        );
      } else {
        return (
          <a className="ant-dropdown-link" onClick={() => handleDisplayModalPdcs(salepoints, record)}>
            {salepoints.length} pdcs(s)
          </a>
        );
      }
    }
  },
  {
    title: "Date de création",
    dataIndex: "created_at",
    key: "created_at",
    render: (text, record, index) => {
      return <div>{moment(text).format("DD/MM/YYYY")}</div>;
    }
  },
  {
    title: "Dernière modification",
    dataIndex: "updated_at",
    key: "updated_at",
    render: (text, record, index) => {
      return <div>{moment(text).format("DD/MM/YYYY")}</div>;
    }
  }
  // {
  //   title: "Actions",
  //   dataIndex: "client.assortmentLabel",
  //   key: "client.assortmentLabel",
  //   render: (text, record, index) => {
  //     return <div>{record.assortmentLabel}</div>
  //   }
  // },
];

export default sectorsColumn;



// WEBPACK FOOTER //
// src/containers/metier/sectors/SectorsList.utils.js